export default {
  isAllDay:(type) => type === 'all_day' ,
  isHours: (type) => type === 'hours',
  isInRange: (start, stop, timeInSeconds) => (isNaN(start) || isNaN(stop)) ? false : (timeInSeconds >= start && timeInSeconds <= stop)
}
